var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapEnergyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8639 25.4536H23.7864V39.2536C23.7864 41.2853 26.3164 42.2436 27.658 40.7103L42.1672 24.227C43.4322 22.7895 42.4164 20.547 40.4997 20.547H34.5772V6.74697C34.5772 4.71531 32.0472 3.75697 30.7055 5.29031L16.1964 21.7736C14.9505 23.2111 15.9664 25.4536 17.8639 25.4536Z",
    fill: "url(#paint0_linear_6206_71373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 9.104H2.875C2.08917 9.104 1.4375 8.45234 1.4375 7.6665C1.4375 6.88067 2.08917 6.229 2.875 6.229H16.2917C17.0775 6.229 17.7292 6.88067 17.7292 7.6665C17.7292 8.45234 17.0775 9.104 16.2917 9.104Z",
    fill: "url(#paint1_linear_6206_71373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 39.771H2.875C2.08917 39.771 1.4375 39.1193 1.4375 38.3335C1.4375 37.5477 2.08917 36.896 2.875 36.896H14.375C15.1608 36.896 15.8125 37.5477 15.8125 38.3335C15.8125 39.1193 15.1608 39.771 14.375 39.771Z",
    fill: "url(#paint2_linear_6206_71373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 24.4375H2.875C2.08917 24.4375 1.4375 23.7858 1.4375 23C1.4375 22.2142 2.08917 21.5625 2.875 21.5625H8.625C9.41083 21.5625 10.0625 22.2142 10.0625 23C10.0625 23.7858 9.41083 24.4375 8.625 24.4375Z",
    fill: "url(#paint3_linear_6206_71373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6206_71373",
    x1: 29.1879,
    y1: 4.53467,
    x2: 29.1879,
    y2: 41.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6206_71373",
    x1: 9.58333,
    y1: 6.229,
    x2: 9.58333,
    y2: 9.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6206_71373",
    x1: 8.625,
    y1: 36.896,
    x2: 8.625,
    y2: 39.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6206_71373",
    x1: 5.75,
    y1: 21.5625,
    x2: 5.75,
    y2: 24.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapEnergyIcon);
export default __webpack_public_path__ + "static/media/map-energy-icon.3126804fcadd361cd9ad6045f085c580.svg";
export { ForwardRef as ReactComponent };